import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import {
  updateApplicantProfile,
  updateCurrentUserWith,
} from 'store/main/ducks/currentUser';
import { useMainDispatch } from 'store/main/hooks/useMainDispatch';
import { dismissResumeDBLoggedOut } from 'utils/resumeDatabase';

const ResumeDatabaseResponseContainer = ({
  children,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: (arg0: { dismiss: (...args: Array<any>) => any }) => ReactNode;
}) => {
  const { currentUser } = useSelector((state) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
    currentUser: state.currentUser,
  }));
  const dispatch = useMainDispatch();

  const dismiss = () => {
    if (currentUser.id) {
      dispatch(
        updateApplicantProfile({
          isRecruitable: false,
        })
      );
    } else {
      dismissResumeDBLoggedOut();
      dispatch(
        updateCurrentUserWith({
          isRecruitable: false,
        })
      );
    }
  };

  return children({
    dismiss,
  });
};

// eslint-disable-next-line import/no-default-export
export default ResumeDatabaseResponseContainer;
